// extracted by mini-css-extract-plugin
export default {"dotPulse":"HeaderIcon_dotPulse__TJ+7d","pulse":"HeaderIcon_pulse__KwUAU"};